const SVGYoutube = () => (
  <svg
    width="33"
    height="32"
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
  >
    {/* <title>Check us out on YouTube</title> */}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.666016 16.0003C0.666016 7.26293 7.7509 0.179932 16.4905 0.179932C25.2302 0.179932 32.3151 7.26293 32.3151 16.0003C32.3151 24.7376 25.2302 31.8206 16.4905 31.8206C7.7509 31.8206 0.666016 24.7376 0.666016 16.0003Z"
      fill="#535360"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.0858 10.4312C23.8121 10.6304 24.3841 11.2175 24.5782 11.963C24.9309 13.3142 24.9309 16.1334 24.9309 16.1334C24.9309 16.1334 24.9309 18.9526 24.5782 20.3038C24.3841 21.0494 23.8121 21.6364 23.0858 21.8358C21.7696 22.1978 16.4913 22.1978 16.4913 22.1978C16.4913 22.1978 11.2131 22.1978 9.89677 21.8358C9.17048 21.6364 8.59851 21.0494 8.4044 20.3038C8.05176 18.9526 8.05176 16.1334 8.05176 16.1334C8.05176 16.1334 8.05176 13.3142 8.4044 11.963C8.59851 11.2175 9.17048 10.6304 9.89677 10.4312C11.2131 10.0691 16.4913 10.0691 16.4913 10.0691C16.4913 10.0691 21.7696 10.0691 23.0858 10.4312ZM14.9089 13.7604V19.0337L19.1287 16.3971L14.9089 13.7604Z"
      fill="white"
    />
  </svg>
);

// eslint-disable-next-line import/no-default-export
export default SVGYoutube;
